module.exports = __webpack_public_path__ + "img/success.b501e5d9.png";